/* The words an API failure carries (state system, 2026-09-04).
 *
 * One source: `ApiError` (./api.ts) builds its message here, so the ~30
 * call sites that render `e.message` all show the same officer sentence —
 * never "API Error 500: Internal Server Error". Pure, no React, so
 * `npm run test:unit` can pin the shape. */

/** "12:31:08" — the local wall clock, for the sentence. */
export function clockStamp(d: Date): string {
  const hh = String(d.getHours()).padStart(2, '0')
  const mm = String(d.getMinutes()).padStart(2, '0')
  const ss = String(d.getSeconds()).padStart(2, '0')
  return `${hh}:${mm}:${ss}`
}

/** Four hex characters the officer can quote to support. The page prefix
 * ("wb-9f31") is added where the page is known (ErrorState). */
export function newReference(): string {
  const bytes = new Uint8Array(2)
  const c = (globalThis as { crypto?: { getRandomValues?: (a: Uint8Array) => Uint8Array } }).crypto
  if (c?.getRandomValues) c.getRandomValues(bytes)
  else for (let i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256)
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('')
}

/** The message on the error itself — lower-case so it reads after an em
 * dash ("The policy catalogue could not be loaded — the server answered
 * HTTP 500 at 12:31:08 · reference 9f31"). Status 0 = the request never
 * got an answer (network down, server unreachable). */
export function apiErrorMessage(status: number, at: Date, reference: string): string {
  const when = clockStamp(at)
  const what = status > 0 ? `the server answered HTTP ${status}` : 'the server could not be reached'
  return `${what} at ${when} · reference ${reference}`
}
